import isEqualWith from 'lodash/isEqualWith'
import isArray from 'lodash/isArray'

const stripTypeName = val => {
	if(!val) {
		return val
	}
	const { __typename, ...obj } = val
	return obj
}
const hasTypeName = obj => !!obj && typeof obj === 'object' && typeof obj.__typename === 'string'
export const isEqualNoTypeNames = (a, b) => isEqualWith(a, b, (obj1, obj2) => {
	const oneHasTypeName = hasTypeName(obj1) || hasTypeName(obj2)
	return oneHasTypeName ? isEqualNoTypeNames(stripTypeName(obj1), stripTypeName(obj2)) : null
})

export const prepareFormData = (data, fieldsArr = []) => {
	if(!data) {
		return {}
	}
	let out = {}
	if(Array.isArray(data)) {
		out = data.map(item => {
			let newItem = {}
			if(!item) {
				return item
			}
			fieldsArr.forEach(field => {
				if(typeof field === 'object') {
					const { fieldName, children } = field
					newItem[fieldName] = prepareFormData(item[fieldName], children)
				} else {
					newItem[field] = item[field]
				}
			})
			return newItem
		})
	} else {
		fieldsArr.forEach(field => {
			if(typeof field === 'object' && !field.noForm) {
				const { fieldName, children } = field
				if(data[fieldName]) {
					out[fieldName] = prepareFormData(data[fieldName], children)
				}
				return
			}
			if(typeof data === 'undefined' || typeof data[field] === 'undefined') {
				return
			}
			const value = data[field]
			if(Array.isArray(value)) {
				out[field] = [ ...value ]
				return
			}
			out[field] = value
		})
	}
	return out
}

export const generateOptimisticPayload = (fieldArr, values, __typename) => {
	let out = {}
	fieldArr.forEach((field) => {
		const isObject = typeof field === 'object'
		const fieldName = isObject ? field.fieldName : field
		const defaultValue = isObject && field.defaultValue ?
			field.defaultValue :
			isArray(field) ? [] : null
		const value = values[fieldName]
		if(isObject && field.isArray) {
			out[fieldName] = Array.isArray(value) ?
				value.map(val => val ? generateOptimisticPayload(field.children, val, field.__typename) : null) :
				defaultValue ? defaultValue : []
		} else if(isObject && !field.noForm) {
			out[fieldName] = value ?
				generateOptimisticPayload(field.children, value, field.__typename) :
				defaultValue
		} else if(typeof value !== 'undefined') {
			out[fieldName] = value
		} else {
			out[fieldName] = defaultValue
		}
	})

	if(__typename) {
		out.__typename = __typename
	}
	return out
}
